import { render } from "./profile.vue?vue&type=template&id=6d1790af&scoped=true"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"

import "../less/profileSettings.less?vue&type=style&index=0&id=6d1790af&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1790af"]])

export default __exports__